import axios from "axios";
import { errorToast } from "./toast";

export const sendEmail = async (emailData) => {
  const apiKey = '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';
  const url = 'https://api.brevo.com/v3/smtp/email';

  try {
    const response = await axios.post(url, emailData, {
      headers: {
        'Content-Type': 'application/json',
        'api-key': apiKey,
      },
    });
    return response.data;
  } catch (error) {
    errorToast('Error sending email:', error.response ? error.response.data : error.message);
  }
};